// extracted by mini-css-extract-plugin
export var search = "search-module--search--89UsZ";
export var searchText = "search-module--search-text--xx3s-";
export var searchIcon = "search-module--search-icon--0jErg";